/** @format */

import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

export default class MetaDescription extends Component {
	render() {
		const { noindex, robots, title, name, content, canonical } = this.props;
		const shouldNoIndex = noindex === true || robots === true;
		return (
			<>
				<Helmet>
					<meta charSet="utf-8" />
					<title>{title}</title>
					<meta name={name} content={content} />
					{canonical && <link rel="canonical" href={canonical} />}
					{shouldNoIndex && <meta name="robots" content="noindex, nofollow" />}
				</Helmet>
			</>
		);
	}
}
